import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export const getDocumentVerifications = (documentId, siteId) => {
  return get(`${url}/leasingDocument/${documentId}/${siteId}/verifications`);
};

export function generateManualVerifications(verificationsToLaunch) {
  return post(`${url}/leasingdocument/generate-manual-verifications`, { verificationsToLaunch });
}

export function getDocumentEntities(documentId, siteId) {
  return get(url + `/leasingDocument/${documentId}/${siteId}/entities`, { documentId, siteId });
}
